import React from 'react';
// import '../../scss/loader.scss';
import '../assets/newstyles/base/_loader.scss';


export default class Loader extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { loader, color, className } = this.props;
        return (
            <div className={ 'loadNone'}>
                {/* <div className={loader ? 'loadPage' : 'loadNone'}> */}
                <div className="load__icon-wrap">
                    <svg className={"load__icon " + className}>
                        <path fill={color ? '#fff' : '#3d81f5'} d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                    </svg>
                </div>
            </div>
        );
    }
}